/* global CONFIG */

import { CONFIG } from "../../../config/bundle/envs/production"

export default {
  isFDBrand (brand) {
    let search = CONFIG.brands.find(x => x.id === brand)
    return search && search.code === 'fd'
  }
}



// WEBPACK FOOTER //
// ./src/modules/plugins/common.js